import React, { createContext, useContext, useReducer } from 'react';

let reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_HISTORY':
      return { ...state, history: action.history };
    case 'UPDATE_SERVICES':
      return { ...state, services: action.services };
    case 'UPDATE_DETAIL':
      return { ...state, detail: action.detail };
    case 'CLEAR_DETAIL':
      return { ...state, detail: null };
    default:
      return state;
  }
};

const initialState = {
  detail: null,
  services: null,
  history: null,
  // review: null,
  // report: null,
};

export const OrderDetailContext = createContext(initialState);

export const OrderDetailContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <OrderDetailContext.Provider value={{ state, dispatch }}>{props.children}</OrderDetailContext.Provider>;
};

export const useOrderDetailContext = () => {
  return useContext(OrderDetailContext);
};
